import { me } from "constants/Client";

export const ROLESARR = ["admin", "staff", "manager", "super admin", "accountant"];

export const ROLES = {
  ADMIN: "admin",
  STAFF: "staff",
  MANAGER: "manager",
  ACCOUNTANT: "accountant",
  SUPER_ADMIN: "super admin",
};

// FOR COMPONENTS
export const INVOICE_COLUMN = () => {
  return me()?.role !== ROLES.MANAGER;
};
export const TASK_BUTTON = () => {
  return me()?.role !== ROLES.ACCOUNTANT;
};
export const TRAINING_BUTTON = () => {
  return me()?.role !== ROLES.ACCOUNTANT;
};
export const SERVICE_BUTTON = () => {
  return me()?.role !== ROLES.ACCOUNTANT;
};
export const PARTICIPANT_BUTTON = () => {
  return me()?.role !== ROLES.ACCOUNTANT;
};
export const EMPLOYEE_BUTTON = () => {
  return me()?.role !== ROLES.ACCOUNTANT;
};
export const INCIDENT_BUTTON = () => {
  return me()?.role !== ROLES.ACCOUNTANT;
};
export const RISK_ASSESSMENT_ACTION = () => {
  return me()?.role !== ROLES.ACCOUNTANT;
};
export const STATUS_TIME_CONTROLS = () => {
  return me()?.role === ROLES.ADMIN;
};
export const SERVICE_RECORD = () => {
  return me()?.role === ROLES.ADMIN;
};
export const NOTICEBOARD_BTN = () => {
  return me()?.role === ROLES.ADMIN;
};
export const PRESCRIBER_BTN = () => {
  return me()?.role !== ROLES.ACCOUNTANT;
};

// FOR ROLE CHECKS
export const IS_STAFF_ROLE = () => {
  return me()?.role === ROLES.STAFF;
};
export const IS_SUPERADMIN_ROLE = () => {
  return me()?.role === ROLES.SUPER_ADMIN;
};
export const IS_ADMIN_ROLE = () => {
  return me()?.role === ROLES.ADMIN;
};
export const IS_WORKSPACE_ADMIN = () => {
  return me()?.workspace_admin;
};
// FOR PAGES
export const SERVICE_PAGE = () => {
  return me()?.role !== ROLES.MANAGER;
};
export const INVOICE_PAGE = () => {
  return me()?.role !== ROLES.MANAGER;
};
export const LOCATION_PAGE = () => {
  return me()?.role !== ROLES.MANAGER;
};
export const INCIDENT_PAGE = () => {
  return me()?.role !== ROLES.ACCOUNTANT;
};
export const MANAGER_PAGE = () => {
  return me()?.role === ROLES.ADMIN;
};

// FOR API CALLS
export const ADMIN_MANAGER_APIS = () => {
  return me()?.role === ROLES.ADMIN || me()?.role === ROLES.MANAGER;
};
